import icon0 from './001-ahead only.png';
import icon1 from './002-crossroads.png';
import icon2 from './003-falling rocks.png';
import icon3 from './004-give way.png';
import icon4 from './005-hump.png';
import icon5 from './006-left turn.png';
import icon6 from './007-parking.png';
import icon7 from './008-level crossing.png';
import icon8 from './009-speed limit.png';
import icon9 from './010-narrow bridge.png';
import icon10 from './011-no bike.png';
import icon11 from './012-no trucks.png';
import icon12 from './013-no alarm.png';
import icon13 from './014-no turn left.png';
import icon14 from './015-no motorcycles.png';
import icon15 from './016-speed limit.png';
import icon16 from './017-no overtaking.png';
import icon17 from './018-pedestrian.png';
import icon18 from './019-no entry.png';
import icon19 from './020-u turn.png';
import icon20 from './021-Two way.png';
import icon21 from './022-pedestrian crossing.png';
import icon22 from './023-right turn.png';
import icon23 from './024-road work.png';
import icon24 from './025-roundabout.png';
import icon25 from './026-pedestrian crossing.png';
import icon26 from './027-Slippery road.png';
import icon27 from './028-traffic lights.png';
import icon28 from './029-turn left.png';
import icon29 from './030-turn right.png';
import icon30 from './031-uneven.png';
import icon31 from './032-maximum.png';
import icon32 from './033-wild animals.png';

const textures = {
  '001-ahead only': icon0,
  '002-crossroads': icon1,
  '003-falling rocks': icon2,
  '004-give way': icon3,
  '005-hump': icon4,
  '006-left turn': icon5,
  '007-parking': icon6,
  '008-level crossing': icon7,
  '009-speed limit': icon8,
  '010-narrow bridge': icon9,
  '011-no bike': icon10,
  '012-no trucks': icon11,
  '013-no alarm': icon12,
  '014-no turn left': icon13,
  '015-no motorcycles': icon14,
  '016-speed limit': icon15,
  '017-no overtaking': icon16,
  '018-pedestrian': icon17,
  '019-no entry': icon18,
  '020-u turn': icon19,
  '021-Two way': icon20,
  '022-pedestrian crossing': icon21,
  '023-right turn': icon22,
  '024-road work': icon23,
  '025-roundabout': icon24,
  '026-pedestrian crossing': icon25,
  '027-Slippery road': icon26,
  '028-traffic lights': icon27,
  '029-turn left': icon28,
  '030-turn right': icon29,
  '031-uneven': icon30,
  '032-maximum': icon31,
  '033-wild animals': icon32,
};

export default textures;